export const OBJECTS_TYPES = {
    call: 'call',
    clazz: 'clazz',
    method: 'method',
    namespace: 'namespace',
}
